import React from 'react'
import getLabels from '../../utils/getLabels'
import Confirmation from '../Confirmation'

const CheckOutPrompt = props => {
  return (
    <div data-element={props.dataElement}>
      {`${getLabels('checkout_prompt')}?`}
      <Confirmation {...props} />
    </div>
  )
}

export default CheckOutPrompt
